import React from 'react';
import * as Fi from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';

import { Skeletons, SkeletonText } from 'ui/components/skeleton';

import { formatDate, currencyFormat } from 'utilities/common';
import { Payment } from 'services/action';
import { FormPayment } from '../form';
import { Document } from './document';

const initialState = {
  payments: null,
  payment: null,
  showDelete: false,
  showUpdate: false,
  showDocument: false,
};

export const PaymentList = ({ data, onSubmit }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Payment.GetReceivable']
  );

  const [{ payments, payment, showDelete, showUpdate, showDocument }, setState] = React.useState(initialState);

  const $handleClose = async() => {
    setState((prevState) => ({ ...prevState, showDelete: false, showUpdate: false, showDocument: false, payment: null }));
  }

  const $onLoad = async() => {
    const req = await Dispatch(Payment.$getReceivable(data?.id));

    if (req?.message === 'success') {
      setState((prevState) => ({ ...prevState, payments: req?.data }));
    }
  }

  const $handleDelete = async (val) => {
    setState((prevState) => ({ ...prevState, showDelete: true, payment: val }));
  };

  const $handleUpdate = async (val) => {
    setState((prevState) => ({ ...prevState, showUpdate: true, payment: val }));
  };

  const $emitDelete = async () => {
    const req = await Dispatch(Payment.$delete(payment?.id));

    if (req?.message === 'success') {
      $handleClose();
      onSubmit();
    }
  };

  React.useEffect(() => {
    if (!data) return
    $onLoad()
  }, [data])

  return (
    <div>
      {StateLoading ? (
        <div className="mb-3">
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
          <Skeletons height="150px" />
        </div>
      ) : (
        <div>
          <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
            Log Pembayaran
          </div>

          {payments?.length > 0 ? (
            <div className="log-container border-0 pt-2">
              {payments
                ?.map((d, i) => (
                  <div
                    key={i}
                    className="border-bottom py-2 pe-2 row m-0 align-items-start"
                  >
                    <div className="col-1 p-0">
                      <Fi.FiCheckCircle color="#2fb344" />
                    </div>
                    <div className="col-7 p-0">
                      <div className="text-start title fs-8 fw-semibold text-capitalize">
                        {d?.is_down_payment ? 'Pemotongan melalui' : 'Pembayaran Diterima'} {d?.payment_method}
                      </div>
                      <div className="text-success fs-8 fw-semibold">
                        {currencyFormat(d?.nominal, 'IDR')}
                      </div>
                      <div className="fs-9 fw-semibold">
                        {d?.paid_by}
                      </div>
                      {d?.attachments?.length > 0 && (
                        <button
                          type="button"
                          className="btn btn-xs me-2"
                          onClick={() => setState((prevState) => ({ ...prevState, showDocument: true, payment: d}))}
                        >
                          Lihat Dokumen
                        </button>
                      )}
                    </div>
                    <div className="col-4 p-0 text-end">
                      <small className="fs-8 text-primary">
                        {formatDate(d?.paid_at)}
                      </small>{' '}
                      {d?.note && (
                        <div className="fs-9 fw-semibold">
                        {d?.note}
                      </div>
                      )}
                      {!d?.is_down_payment && (
                        <div className="ms-n3">
                          <button
                            type="button"
                            className="btn btn-danger btn-xs me-2"
                            onClick={() => $handleDelete(d)}
                          >
                            Hapus
                          </button>
                          <button
                            type="button"
                            className="btn btn-xs"
                            onClick={() => $handleUpdate(d)}
                          >
                            Edit
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))
                .reverse()}
            </div>
          ) : (
            <div className="hr-text text-italic mt-4 mb-5"> belum ada </div>
          )}
        </div>
      )}

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div
            className="btn-close"
            onClick={$handleClose}
          />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={() => $emitDelete()}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* perbaharui payment */}
      <Modal
        show={showUpdate}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Perbaharui Pembayaran</Modal.Title>
        </Modal.Header>
        <FormPayment
          data={data}
          payment={payment}
          onClose={() => {
            $handleClose();
            onSubmit();
          }}
        />
      </Modal>

      {/* modal dokumen */}
      <Modal
        show={showDocument}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="xl"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Dokumen Pembayaran</Modal.Title>
        </Modal.Header>
        <Document data={payment} onClose={() => {
          $handleClose();
          onSubmit();
        }} />
      </Modal>
    </div>
  );
};
